// src/utils/platform.js
//
// What kind of browser is this, for install guidance. The answer matters because
// the install steps differ and some browsers cannot install at all:
//
//   ios-safari       the only reliable place to Add to Home Screen on iPhone/iPad
//   ios-other        Chrome/Edge/Firefox on iOS, or an in-app browser (WhatsApp,
//                    Instagram, Gmail…). Safari is the one to send them to.
//   android-chrome   gets a real install prompt
//   android-webview  an in-app browser — has to be reopened in Chrome
//   desktop          show a QR code to scan with a phone

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

export function isIos() {
  const ua = window.navigator.userAgent;
  // iPadOS 13+ reports itself as a Mac; touch points tell them apart.
  return /iphone|ipad|ipod/i.test(ua)
    || (/macintosh/i.test(ua) && window.navigator.maxTouchPoints > 1);
}

export function isIosSafari() {
  const ua = window.navigator.userAgent;
  // Real Safari carries a "Safari/" token. In-app web views (WKWebView) don't,
  // and the other iOS browsers announce themselves with CriOS/FxiOS/EdgiOS.
  return isIos() && /safari\//i.test(ua) && !/crios|fxios|edgios|opios|gsa\//i.test(ua);
}

export function getPlatform() {
  const ua = window.navigator.userAgent;
  if (isIos()) return isIosSafari() ? 'ios-safari' : 'ios-other';
  if (/android/i.test(ua)) return /;\s*wv\)|\bversion\/[\d.]+.*chrome/i.test(ua) ? 'android-webview' : 'android-chrome';
  return 'desktop';
}
